import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import QRCode from 'qrcode.react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faDownload } from '@fortawesome/free-solid-svg-icons';

const QRWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media print {
    margin-top: 100px;
  }
`;

const TitlePrint = styled.div`
  display: none;
  justify-content: center;
  @media print {
    display: flex;
    margin-top: 75px;
  }
`;

const NoPrint = styled.div`
  @media print {
    display: none;
  }
`;

interface QRDialogProps {
  closeFn: () => void;
  open: boolean;
  productName: string;
  qrDescription: string;
  qrValue: string;
  siteName?: string;
}

const downloadQRCode = (fileName: string) => {
  const svgElement = document.getElementById("qr-code") as SVGElement | null;
  if (!svgElement) {
      console.error("QR code SVG element not found!");
      return;
  }

  // Serialize the SVG element to a string
  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(svgElement);

  // Create a data URL for the SVG
  const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(svgBlob);

  // Create an image to render the SVG
  const img = new Image();
  img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = svgElement.clientWidth;
      canvas.height = svgElement.clientHeight;

      const ctx = canvas.getContext("2d");
      if (!ctx) {
          console.error("Failed to get canvas context.");
          return;
      }

      // Draw the SVG onto the canvas
      ctx.drawImage(img, 0, 0);

      // Create a PNG download link
      const pngUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = `${fileName}.png`;
      link.click();

      // Clean up
      URL.revokeObjectURL(url);
  };

  img.src = url;
};

// TODO: refactor
const QRDialog: FC<QRDialogProps> = ({ closeFn, open, productName, qrValue, siteName, qrDescription }) => {
  const { t } = useTranslation();
  return (
    <Dialog aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description" open={open} fullScreen>
      <TitlePrint>
        <Typography variant="h6">{siteName}</Typography>
      </TitlePrint>
      <AppBar position="sticky">
        <NoPrint>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={closeFn} aria-label="close">
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              {t('label.qr code')}
            </Typography>

            <Button color="inherit" onClick={() => window.print()}>
              {t('label.print')}&nbsp;
              <FontAwesomeIcon icon={faPrint} />
            </Button>

            <Button color="inherit" onClick={() => {
              // window.print();
              let fileName = siteName ? `${productName}-${siteName}-${qrDescription}` : `${productName}-${qrDescription}`;
              fileName = fileName.replaceAll(" ", "");
              downloadQRCode(fileName);
            }}>
              {t('label.download')}&nbsp;
              <FontAwesomeIcon icon={faDownload} />
            </Button>
          </Toolbar>
        </NoPrint>
      </AppBar>
      <QRWrapper id="qr-container">
        <span style={{ fontSize: '25px', marginBottom: '50px' }}>{productName}</span>
        <QRCode id="qr-code" value={qrValue} renderAs="svg" size={384} />
        <div style={{marginBottom: '30px'}}></div>
        {siteName && <span style={{ fontSize: '25px', marginBottom: '30px' }}>{siteName}</span>}
        <span style={{ fontSize: '25px', marginBottom: '30px' }}>{qrDescription}</span>
      </QRWrapper>
    </Dialog>
  );
};

export { QRDialog };
